import React from 'react';

import PanelRedesSociales from '../Utilitarios/PanelRedesSociales/index';
import NavBar from '../Utilitarios/NavBar/index';
import BannerPrincipal from '../Utilitarios/BannerPrincipal/index';
import BotonGhost2 from '../Utilitarios/BotonGhost2/index';
import PanelCardEspecialesInicio from '../Utilitarios/PanelCardEspecialesInicio/index';
import BannerCentro from '../Utilitarios/BannerCentro/index';
import CardVideo from '../Utilitarios/CardVideo/index';
import Footer from '../Utilitarios/Footer';
import './css/styles.css';

class Inicio extends React.Component{

    constructor(props){
        super(props);
        this.scrollUp = this.scrollUp.bind(this);
    }

    componentWillMount(){
        document.body.style.backgroundImage = 'none';
    }

    scrollUp(){
        window.scrollTo(0, 0);
    }

    render(){

        let  text= "La unidad de investigación Periodística se constituye como un espacio de formación " +
                   "en el cual los estudiantes aprenden haciendo, en un ejercicio interdisciplinar entre" +
                   " periodístas, realizadores audiovisuales y diseñadores gráficos, en compañia de " +
                   "docentes de las áreas señaladas.";

        return(
            <div className="container_inicio">
                <PanelRedesSociales />
                <NavBar />
                <BannerPrincipal />
                <PanelCardEspecialesInicio />
                <BannerCentro texto={`#SinReclutamientoInfantil`}/>
                <section className="background_video_inicial_principal">
                    <BotonGhost2 text="Unidad de Investigacion Periodística"
                                        boxLeft="s12 m1"
                                        boxCenter="s12 m10"
                                        boxRight="s12 m1" />
                    <CardVideo texto={text}/>
                </section>
                <Footer />
                <a class="btn-floating btn-large waves-effect waves-light pink button_top_all"
                   onClick={this.scrollUp}>
                    <i class="material-icons">expand_less</i>
                </a>
            </div>
        );
    }
}

export default Inicio;